<template>
  <div>
    <div class="demo-title">
      <SectionTitle>
        <!-- Veja alguns modelos de demonstração:  -->
        Acesse os modelos e faça um pedido teste:
      </SectionTitle>
      <div class="foward-backward-buttons">
        <v-btn
          icon
          @click="prevSlide"
          class="button"
          aria-label="Voltar ao slide anterior"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn
          icon
          @click="nextSlide"
          class="button"
          aria-label="Avançar para o próximo slide"
        >
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="carousel-container mt-8">
      <div class="swiper modelosSwiper">
        <div class="swiper-wrapper">
          <div
            v-for="(item, i) in carousel"
            :key="i"
            class="swiper-slide d-flex flex-column align-center"
          >
            <div v-html="item.name" />
            <img
              @click="openUrl(item.url)"
              :src="require(`@/assets/images/modelos/${item.image}`)"
              class="img-fluid"
              :alt="item.image"
              loading="lazy"
            />
            <v-btn
              @click="openUrl(item.url)"
              small
              class="white--text red darken-1 mt-2"
            >
              Acessar
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SectionTitle from "@/components/SectionTitle.vue";

  export default {
    name: "DemoCarousel",

    components: {
      SectionTitle,
    },

    data: () => ({
      carousel: [
        {
          name: 'Modelo&nbsp;Restaurante',
          image: "modelo-restaurante.png",
          url: "https://app.zapermenu.com.br/modelo-restaurante",
        },
        {
          name: 'Modelo&nbsp;Hamburg.',
          image: "modelo-hamburgueria.png",
          url: "https://app.zapermenu.com.br/modelo-hamburgueria",
        },
        {
          name: 'Modelo&nbsp;Salgaderia',
          image: "modelo-salgaderia.png",
          url: "https://app.zapermenu.com.br/modelo-salgaderia",
        },
        {
          name: 'Modelo&nbsp;Açaí',
          image: "modelo-acai.png",
          url: "https://app.zapermenu.com.br/modelo-acai",
        },
        {
          name: 'Modelo&nbsp;Pizzaria',
          image: "modelo-pizzaria.png",
          url: "https://app.zapermenu.com.br/modelo-pizzaria",
        },
        {
          name: 'Modelo&nbsp;Confeitaria',
          image: "modelo-confeitaria.png",
          url: "https://app.zapermenu.com.br/modelo-confeitaria",
        },
        {
          name: 'Modelo&nbsp;Marmitaria',
          image: "modelo-marmitaria.png",
          url: "https://app.zapermenu.com.br/modelo-marmitaria",
        },
        {
          name: 'Modelo&nbsp;Sushi',
          image: "modelo-sushi.png",
          url: "https://app.zapermenu.com.br/modelo-sushi",
        },
        {
          name: 'Modelo&nbsp;Hortifruti',
          image: "modelo-hortifruti.png",
          url: "https://app.zapermenu.com.br/modelo-hortifruti",
        },
      ],
    }),

    mounted() {
      // eslint-disable-next-line
      this.swiper = new Swiper(".modelosSwiper", {
        slidesPerView: 2,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 50,
          },
        },
      });
    },

    methods: {
      openUrl(url) {
        window.open(url, "_blank");
      },
      prevSlide() {
        this.swiper.slidePrev();
      },
      nextSlide() {
        this.swiper.slideNext();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .demo-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    :deep(.section-title) {
      width: 50%;
      line-height: 56px;
      font-size: 32px;
    }
    @media (max-width: 768px) {
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      :deep(.section-title) {
        width: 100%;
        line-height: 32px;
        font-size: 24px;
        margin-bottom: 16px;
      }
    }
    .foward-backward-buttons {
      display: flex;
      gap: 16px;
      .button {
        border: 1px solid #c3121a;
        background-color: var(--btn-icon-bg);
        color: var(--text-primary);
        :deep(.v-icon) {
          font-size: 18px;
        }
      }
    }
  }

  .carousel-container {
    width: 100%;
    overflow: hidden;
  }

  .img-fluid {
    max-width: 100%;
    height: auto;
  }
</style>
